export const mockPoolPoints = {
  dataDate: new Date().toISOString(),
  pool: 'LR2',
  poolAverage: 102.5,
  poolAverageRatio: 1.02,
  poolPartner: 'Test Pool Partner',
  vesselCode: 'TEST001',
  vesselIMONumber: '1234567',
  vesselName: 'Test Vessel',
  vesselStatus: 'Active',
  vesselVTId: 'vt-123',
  version: '2025-07',
  sections: [
    {
      label: 'Cargo Capacity',
      range: { min: 0, max: 10 },
      result: 8,
      fields: [
        {
          label: 'DWT',
          input: 115000,
          range: { min: 0, max: 5 },
          result: 4,
        },
        {
          label: 'Cubic Capacity',
          input: 130000,
          range: { min: 0, max: 5 },
          result: 4,
        },
      ],
    },
    {
      label: 'Fuel Efficiency',
      range: { min: 0, max: 15 },
      result: 12,
      fields: [
        {
          label: 'Main Engine Consumption',
          input: '45 mt/day',
          range: { min: 0, max: 10 },
          result: 8,
          hint: 'Based on design consumption at 14.5 knots',
        },
        {
          label: 'Eco Speed',
          input: '12.5 knots',
          range: { min: 0, max: 5 },
          result: 4,
        },
      ],
    },
  ],
  totalPoolPoints: {
    result: 100,
    range: { min: 80, max: 120 },
    label: 'Total Pool Points',
    fields: [],
  },
  poolPointsCorrections: {
    result: 5,
    input: [
      {
        poolPoints: 3,
        reason: 'Scrubber Installation Bonus',
        validFrom: '2024-01-01',
        validTo: '2025-12-31',
        createdAt: '2024-01-15T10:00:00Z',
        createdBy: 'admin@test.com',
        hash: 'correction-1',
      },
      {
        poolPoints: 2,
        reason: 'BWTS Upgrade Credit',
        validFrom: '2024-06-01',
        validTo: '2025-06-30',
        createdAt: '2024-06-01T08:30:00Z',
        createdBy: 'operator@test.com',
        hash: 'correction-2',
      },
    ],
  },
  totalPoolPointsPlusCorrections: {
    result: 105,
  },
}
